import React, { useState, useCallback } from 'react';
import { Popover } from '@superops/ui-design-system';
import { DisabledTag } from '@nile/components';
import styled from 'styled-components';

const MoreOptionsParent = styled.div`
  .option-block {
    font-weight: 500;
    font-size: ${(props) => (props.fontSize ? props.fontSize : '14px')};
    color: ${(props) => (props.color ? props.color : 'rgba(0, 0, 0, 0.8)')};
    cursor: default;
  }
`;

const MultipleNamesHandlerParent = styled(MoreOptionsParent)`
  .more-block {
    font-weight: 500;
    font-size: ${(props) => (props.fontSize ? props.fontSize : '14px')};
    color: #0000ff;
    margin-left: 4px;
  }
`;

const MultipleNamesHandler = (props) => {
  const { data } = props;

  const [popoverActive, setPopoverActive] = useState(false);

  const togglePopover = useCallback(() => {
    setPopoverActive(!popoverActive);
  });

  const popoverActivator = (
    <div onClick={togglePopover}>{` + ${data.length - 1} more`}</div>
  );

  if (Array.isArray(data)) {
    if (data.length === 0) {
      return <DisabledTag>NA</DisabledTag>;
    }

    if (data.length === 1) {
      return (
        <MultipleNamesHandlerParent
          fontSize={props.fontSize}
          color={props.color}
        >
          <div className="option-block">{data[0].name}</div>
        </MultipleNamesHandlerParent>
      );
    }

    if (data.length > 1) {
      return (
        <MultipleNamesHandlerParent
          fontSize={props.fontSize}
          color={props.color}
        >
          <div className="name-block flex-row flex-align-center ellipsis">
            <div className="option-block ellipsis">{`${data[0].name} `}</div>
            <div className="more-block cursor-pointer">
              <Popover
                activator={popoverActivator}
                active={popoverActive}
                onClose={() => {}}
              >
                <MoreOptionsParent
                  fontSize={props.fontSize}
                  color={props.color}
                >
                  {data.slice(1).map((el) => {
                    return (
                      <div className="flex-row cursor-pointer p4 option-block">
                        {el.name}
                      </div>
                    );
                  })}
                </MoreOptionsParent>
              </Popover>
            </div>
          </div>
        </MultipleNamesHandlerParent>
      );
    }
  }

  console.error('invalid input');
};

export default MultipleNamesHandler;
